import { Icon, IconTypes } from '@eika/icon';
import './profit-tag.scss';
import { formatPercentage } from '@components/savings-calculator/functions';
import { ScreenReaderElement } from '@components/screen-reader/screen-reader-element';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';

type ProfitTagProps = {
    color?: string;
} & ({ percentage: number; label?: never } | { label: string; percentage?: never });

export const ProfitTag = (props: ProfitTagProps) => {
    const { totalsPanel } = useTranslation();
    const { color } = props;
    const text = props.label ?? formatPercentage(props.percentage);
    const screenReaderText = props.label ?? format(totalsPanel.profitTagA11yPercent, text);

    return (
        <>
            <div className="profit-tag" aria-hidden="true" style={color ? { backgroundColor: color } : {}}>
                <Icon type={IconTypes.PIL_OPP} />
                <span>{text}</span>
            </div>
            <ScreenReaderElement text={screenReaderText} />
        </>
    );
};
